<template>
<div class="base-radio-group">
  <el-radio v-for="item in items" :key="item.id" v-model="localModel" :label="item.id">{{ item.label }}</el-radio>
</div>
</template>

<script>
export default {
  name: 'BaseRadioGroup',
  props: {
    items: { type: Array, required: true },
    value: { type: [String, Number], default: '' }
  },
  model: {
    prop: 'value',
    event: 'update:value'
  },
  computed: {
    localModel: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('update:value', v)
      }
    }
  }
}
</script>
